import { render, staticRenderFns } from "./RightMenuEdit_Ap.vue?vue&type=template&id=c364c914&scoped=true"
import script from "./RightMenuEdit_Ap.vue?vue&type=script&lang=js"
export * from "./RightMenuEdit_Ap.vue?vue&type=script&lang=js"
import style0 from "./RightMenuEdit_Ap.vue?vue&type=style&index=0&id=c364c914&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c364c914",
  null
  
)

export default component.exports